import React, { useState, useEffect } from 'react';
import { Radio, Space, Divider } from 'antd';
import RoleSelect from '../FormRoleSelect/RoleSelect';
import MenuFuncSelect from '../FormMenuFuncSelect/MenuFuncSelect';

const RoleMenuFuncSelect = ({ value, onChange, selectionMode = 'role_only' }) => {
  const [mode, setMode] = useState(selectionMode);
  const [roleValue, setRoleValue] = useState([]);
  const [funcValue, setFuncValue] = useState([]);

  // 初始化值
  useEffect(() => {
    if (value) {
      setMode(value.mode || 'role_only');
      setRoleValue(value.roles || []);
      setFuncValue(value.functions || []);
    }
  }, [value]);

  // 模式选项
  const modeOptions = [
    { label: '仅角色', value: 'role_only' },
    { label: '仅功能', value: 'func_only' },
    { label: '角色+功能', value: 'role_and_func' },
    { label: '角色或功能', value: 'role_or_func' }
  ];

  // 处理模式变化
  const handleModeChange = (e) => {
    const newMode = e.target.value;
    setMode(newMode);
    
    // 根据模式清理不需要的值
    let newRoleValue = roleValue;
    let newFuncValue = funcValue;
    
    if (newMode === 'func_only') {
      newRoleValue = [];
    } else if (newMode === 'role_only') {
      newFuncValue = [];
    }
    
    setRoleValue(newRoleValue);
    setFuncValue(newFuncValue);
    
    // 触发onChange
    onChange?.({
      mode: newMode,
      roles: newRoleValue,
      functions: newFuncValue
    });
  };

  // 处理角色选择变化
  const handleRoleChange = (roles) => {
    setRoleValue(roles || []);
    onChange?.({
      mode,
      roles: roles || [],
      functions: funcValue
    });
  };

  // 处理功能选择变化
  const handleFuncChange = (functions) => {
    setFuncValue(functions || []);
    onChange?.({
      mode,
      roles: roleValue,
      functions: functions || []
    });
  };

  // 判断是否显示角色选择器
  const showRoleSelect = mode === 'role_only' || mode === 'role_and_func' || mode === 'role_or_func';
  
  // 判断是否显示功能选择器
  const showFuncSelect = mode === 'func_only' || mode === 'role_and_func' || mode === 'role_or_func';

  return (
    <div>
      {/* 模式选择 */}
      <Radio.Group 
        value={mode} 
        onChange={handleModeChange}
        style={{ marginBottom: 16 }}
      >
        <Space direction="horizontal" wrap>
          {modeOptions.map(option => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      
      <Divider style={{ margin: '12px 0' }} />
      
      {/* 选择器区域 */}
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {/* 角色选择器 */}
        {showRoleSelect && (
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500, color: '#666' }}>
              选择角色:
            </div>
            <RoleSelect 
              value={roleValue}
              onChange={handleRoleChange}
            />
          </div>
        )}
        
        {/* 功能选择器 */}
        {showFuncSelect && (
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500, color: '#666' }}>
              选择功能:
            </div>
            <MenuFuncSelect 
              value={funcValue}
              onChange={handleFuncChange}
              onlySelectFunctions={true}
            />
          </div>
        )}
      </Space>
    </div>
  );
};

export default RoleMenuFuncSelect;